import { useSelector } from 'react-redux'

import type { RootState } from 'store'

export const useAppSelector = <TSelected = unknown>(
  selector: (selector: RootState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
) => useSelector<RootState, TSelected>(selector, equalityFn)
